/* The free-shipping bar (snippets/il-ship-bar.liquid): how far the cart is from free
   shipping, in the cart sheet and on the cart page, following the cart as it changes.
   Loaded on every page (layout/theme.liquid): the cart sheet draws the cart section after
   the page has loaded (assets/il-cart-sheet.js announces it, il:cart-rendered), and a
   script inside drawn HTML does not run. */
(function () {
  let words = {};
  try { words = JSON.parse(document.getElementById('il-i18n')?.textContent || '{}'); } catch { /* the bar stays hidden without its words */ }

  /* As Liquid writes prices (window.ilMoney, snippets/il-i18n.liquid); the browser's own
     formatter only where that is missing. */
  const money = (cents) => window.ilMoney ? window.ilMoney(cents) : new Intl.NumberFormat(document.documentElement.lang || 'en', {
    style: 'currency', currency: window.Shopify?.currency?.active || 'EUR',
  }).format(cents / 100);

  /* A listed currency has its rate's own amount; any other gets the shop currency's
     amount at the day's rate, as Shopify converts the rate's condition. */
  function threshold(el) {
    const here = Number(el.dataset.shipHere) || 0;
    if (here > 0) return here;
    const base = Number(el.dataset.shipBase) || 0;
    const rate = Number(window.Shopify?.currency?.rate) || 1;
    return base > 0 ? Math.round(base * rate) : 0;
  }

  /* offer: the cart is marked "Thank-you offer" (the thank-you page's one-time sign offer,
     il-cart-sheet.js), whose free-shipping code is on it, so the order ships free. */
  function draw(el, total, ships, offer) {
    const from = threshold(el);
    const text = el.querySelector('[data-ship-text]');
    if (!from || !ships || !words['ship.left'] || !text) { el.hidden = true; return; }
    const left = offer ? 0 : from - total;
    if (left > 0) {
      const [before, after = ''] = String(words['ship.left']).split('{amount}');
      const amount = document.createElement('b');
      amount.textContent = money(left);
      text.replaceChildren(before, amount, after);
      el.removeAttribute('data-free');
    } else {
      text.textContent = words['ship.free'] || '';
      el.setAttribute('data-free', '');
    }
    el.querySelector('[data-ship-fill]').style.width = (offer ? 100 : Math.min(100, Math.max(0, (total / from) * 100))) + '%';
    el.hidden = false;
  }

  /* A bar drawn by Liquid carries its cart's figures; draw each one once. */
  function setUp() {
    document.querySelectorAll('[data-ship-bar]:not([data-ship-ready])').forEach((el) => {
      el.setAttribute('data-ship-ready', '');
      draw(el, Number(el.dataset.shipTotal) || 0, el.dataset.shipShips === 'true', el.hasAttribute('data-ship-offer'));
    });
  }
  setUp();
  document.addEventListener('il:cart-rendered', setUp);

  /* What ships: the total after discounts, less what does not ship (the priority service). */
  function onCart(event) {
    const cart = event.detail?.cart;
    if (!cart) return;
    const items = cart.items || [];
    const total = items.reduce((sum, i) => (i.requires_shipping === false ? sum - (i.final_line_price ?? i.line_price ?? 0) : sum), cart.total_price || 0);
    const ships = items.some((i) => i.requires_shipping !== false);
    const offer = !!(cart.attributes && cart.attributes['Thank-you offer']);
    document.querySelectorAll('[data-ship-bar]').forEach((el) => draw(el, total, ships, offer));
  }
  document.addEventListener('il:cart-contents', onCart);
  document.addEventListener('il:cart-updated', onCart);
})();
